import {
  SideBarDef,
  ToolPanelColumnCompParams,
  ToolPanelDef,
} from '@ag-grid-community/core'

export const heliosDefaultToolPanels: ToolPanelDef[] = [
  {
    id: 'columns',
    labelDefault: 'Columns',
    labelKey: 'columns',
    iconKey: 'columns',
    toolPanel: 'agColumnsToolPanel',
    toolPanelParams: {
      suppressRowGroups: true,
      suppressPivots: true,
      suppressPivotMode: true,
      suppressValues: true,
      suppressColumnSelectAll: true,
    } as ToolPanelColumnCompParams,
  },
]

/**
 * Generates the sidebar components.
 *
 * Reason why it's a function instead of a const.
 *
 * For some reason, when you define it as a const, Ag Grid
 * says that the nfApplyAllFiltersPanel is not registered.
 * Probably some race condition.
 */
export function generateHeliosAgGridSidebar(
  additionalToolPanels: ToolPanelDef[] = [],
): SideBarDef {
  /**
   * This registers the apply all filters
   *
   * A new array has to be created otherwise
   * the sidebar tool panels will be duplicated
   * for each grid because it would be a reference
   * to the same object
   */
  return {
    toolPanels: [...heliosDefaultToolPanels, ...additionalToolPanels],
    defaultToolPanel: '',
  } as SideBarDef
}

/**
 * Generates the sidebar components.
 *
 * Reason why it's a function instead of a const.
 *
 * For some reason, when you define it as a const, Ag Grid
 * says that the nfApplyAllFiltersPanel is not registered.
 * Probably some race condition.
 */
export function generateHeliosAgGridSidebarFromScratch(
  additionalToolPanels: ToolPanelDef[] = [],
): SideBarDef {
  /**
   * This registers the apply all filters
   *
   * A new array has to be created otherwise
   * the sidebar tool panels will be duplicated
   * for each grid because it would be a reference
   * to the same object
   */
  return {
    toolPanels: additionalToolPanels,
    defaultToolPanel: '',
  } as SideBarDef
}
